import React, { useEffect, useRef, useState } from 'react';
import ReactPlayer from 'react-player';

interface IVideoPlayer {
  url: string;
  pauseVideoChange: boolean;
  pauseScrollChange?: boolean;
  videoSx?: React.CSSProperties;
  thumbnailUrl?: string;
  fullScreenView?: boolean;
  callBack?: () => void;
}

const CustomVideoPlayer: React.FC<IVideoPlayer> = ({
  url,
  pauseVideoChange,
  pauseScrollChange,
  videoSx,
  thumbnailUrl,
  fullScreenView,
  callBack
}) => {
  const [playing, setPlaying] = useState<boolean>(false);
  const playerRef = useRef<ReactPlayer | null>(null);

  const handleVideoPress = () => {
    if (fullScreenView) {
      setPlaying(prev => !prev); 
    }
  };

  useEffect(() => {
    if (fullScreenView && pauseVideoChange) {
      setPlaying(true);
    } else {
      setPlaying(false);
    }
  }, [fullScreenView, pauseVideoChange, pauseScrollChange]);

  return (
    <ReactPlayer
      ref={playerRef}
      url={url}
      playing={playing}
      light={thumbnailUrl}
      controls
      width='100%'
      height={videoSx?.height}
      onClick={(event: any) => {
        handleVideoPress();
        if (!fullScreenView) {
          setPlaying(false); 
        }
        callBack?.();
        event.preventDefault();
        event.stopPropagation();
      }}
      onClickPreview={(event: any) => {
        setPlaying(true);
        callBack?.();
        event.preventDefault();
        event.stopPropagation();
      }}
      onPause={() => setPlaying(false)}
      onPlay={() => setPlaying(true)} 
    />
  );
};

export default CustomVideoPlayer;
